import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "b-popular-destinations" }
const _hoisted_2 = { class: "p-product-home--layout-title black bold" }
const _hoisted_3 = {
  key: 0,
  class: "p-product-home--layout-subtitle grey regular"
}
const _hoisted_4 = { class: "b-popular-destinations__wrapper" }
const _hoisted_5 = { class: "flex between-xs" }

import { PropType } from 'vue';
  import PopularDestinationItemComponent from './PopularDestinationItemComponent.vue';
  import { FlightSearch } from 'types';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PopularDestinationsContainerComponent',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    destinations: {
      type: Array as PropType<Array<FlightSearch.Destination>>,
      required: true,
    },
  },
  emits: ['onDestinationClick'],
  setup(__props, { emit }) {

  

  

  function onDestinationClick(destination: FlightSearch.Destination) {
    emit('onDestinationClick', destination);
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
    (__props.subtitle)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.subtitle), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.destinations, (item, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            _createVNode(PopularDestinationItemComponent, {
              link: item.link,
              image: item.image,
              asButton: item.destinationIATA != null,
              onOnClick: ($event: any) => (onDestinationClick(item)),
              title: item.title
            }, null, 8, ["link", "image", "asButton", "onOnClick", "title"])
          ]))
        }), 128))
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})